// extracted by mini-css-extract-plugin
export default {"text":"StripeAccountSetupResults_text__s7HQJ"};